import { useState, useEffect, useCallback } from 'react'
import { db, isAbortError } from '../lib/supabase'

export default function useAdminData() {
  const [submissions, setSubmissions] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchSubmissions = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const data = await db.getSubmissions()
      setSubmissions(data)
    } catch (err) {
      if (isAbortError(err)) return
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchSubmissions()
  }, [fetchSubmissions])

  const removeSubmission = (id) => {
    setSubmissions(prev => prev.filter(s => s.id !== id))
  }

  return { submissions, loading, error, refresh: fetchSubmissions, removeSubmission }
}
